import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, delay, ease: EASE }}>
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, delay = 0, lineClass = "" }) =>
  lines.map((l, i) => (
    <span key={i} className="block overflow-hidden pb-[0.1em]">
      <motion.span className={`block ${lineClass}`} initial={{ y: "110%" }} animate={{ y: 0 }}
        transition={{ duration: 1.15, delay: delay + i * 0.14, ease: [0.76, 0, 0.24, 1] }}>
        {l}
      </motion.span>
    </span>
  ));
